import type { QuotesConfig } from '../../../domain/types/configs/company/QuotesConfig';

export const quotesConfig: QuotesConfig = {
  lenght: 8,
  numeration: 1,
  prefix: "SQ"
}; 